import { render, staticRenderFns } from "./ChristmasLibations2025_defaultSection.vue?vue&type=template&id=5a06a192&scoped=true"
import script from "./ChristmasLibations2025_defaultSection.vue?vue&type=script&lang=ts"
export * from "./ChristmasLibations2025_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./ChristmasLibations2025_defaultSection.vue?vue&type=style&index=0&id=5a06a192&prod&lang=css"
import style1 from "./ChristmasLibations2025_defaultSection.vue?vue&type=style&index=1&id=5a06a192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06a192",
  null
  
)

export default component.exports